import {
  cloneDeep,
  forEach,
  isArray,
  isNil,
  omit,
} from "lodash-es";

export function setMainAndAppliedModel({ filterMain, model }) {
  const MAIN_ID = filterMain?.id;
  if (!MAIN_ID) {
    return {
      main: {},
      applied: model,
    };
  }

  return {
    main: {
      [MAIN_ID]: cloneDeep(model?.[MAIN_ID]) || undefined,
    },
    applied: omit(model, [MAIN_ID]),
  };
}

export function getModelFromAFiltersWithModelId({ model = {}, filtersKeyById = {} }) {
  const MODEL_NEW = {};
  const MODEL = cloneDeep(model);
  forEach(MODEL, (modelValue, filterId) => {
    if (isNil(modelValue)) {
      return;
    }

    if (!filtersKeyById[filterId]) { // erste Ladung
      MODEL_NEW[filterId] = modelValue;
      return;
    }
    const MODEL_ID = filtersKeyById[filterId].modelId;

    if (!MODEL_ID) {
      MODEL_NEW[filterId] = modelValue;
      return;
    }

    if (!MODEL_NEW[MODEL_ID]) {
      MODEL_NEW[MODEL_ID] = modelValue;
    } else if (isArray(MODEL_NEW[MODEL_ID])) {
      if (isArray(modelValue)) {
        MODEL_NEW[MODEL_ID].push(...modelValue);
      } else {
        MODEL_NEW[MODEL_ID].push(modelValue);
      }
    }
  });

  return MODEL_NEW;
}
